import React from 'react';

import { Avatar, Separator } from '@radix-ui/themes';
import classNames from 'classnames';

type SubMenuProps = {
  avatar?: string;
  title: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
  triangle?: 'left' | 'right';
  children?: React.ReactNode;
};

export const FlySubMenu = ({
  avatar,
  title,
  footer,
  triangle,
  className = '',
  children,
  ...rest
}: SubMenuProps) => {
  return (
    <div
      className={classNames(
        'rounded-5 border-gray-5 absolute z-[1000] border bg-(--body-bg)',
        className
      )}
      {...rest}
    >
      {triangle && <div className={classNames(`triangle-${triangle}`)} />}
      <header className='flex items-center gap-fly-4 pt-fly-4 pr-fly-5 pb-fly-4 pl-fly-5'>
        {avatar && <Avatar fallback={avatar} size='3' radius='full' />}
        <div className='overflow-hidden text-ellipsis whitespace-nowrap'>
          {title}
        </div>
      </header>
      <Separator size='1' className='w-full' />
      {children}
      {footer && (
        <footer className='w-full'>
          <Separator size='1' className='w-full' />
          <div className='pt-fly-4 pr-fly-5 pb-fly-4 pl-fly-5'>{footer}</div>
        </footer>
      )}
    </div>
  );
};
